import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import '@radix-ui/themes/styles.css';
import './index.css';
import '@fontsource/montserrat';

import App from './App';
import { configureSentry } from './lib/sentry/config';

// Configure sentry
configureSentry();

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
